import { Badge } from '@vipso/shared';
import { useTranslation } from 'react-i18next';

const STATUS_COLOR: Record<string, string> = {
  DRAFT: 'gray',
  PENDING: 'yellow',
  APPROVED: 'green',
  REJECTED: 'red',
};

export function ApprovalStatusBadge({ status }: { status?: string | null }) {
  const { t } = useTranslation();
  if (!status) return null;
  const key = status.toLowerCase();
  const label =
    key === 'draft'
      ? t('approval.draft')
      : key === 'pending'
        ? t('approval.pending')
        : key === 'approved'
          ? t('approval.approved')
          : key === 'rejected'
            ? t('approval.rejected')
            : status;
  return (
    <Badge size="sm" variant="light" color={STATUS_COLOR[status] ?? 'gray'}>
      {label}
    </Badge>
  );
}
